module.exports = __webpack_public_path__ + "static/icons/icon-map--argentina-87827569d55e257b7810dda86e5291f2.svg";